import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { LayoutHorizontal } from '../Layout/LayoutHorizontal';
import { IconCompanies } from '../Icons/IconCompanies';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledLayoutHorizontal = styled(LayoutHorizontal).withConfig({
  displayName: "CompanyLogo__StyledLayoutHorizontal",
  componentId: "juydo-0"
})(["font-size:", ";svg{inline-size:0.5em;block-size:0.5em;}"], ({
  $size
}) => $size);
const Image = styled.img.withConfig({
  displayName: "CompanyLogo__Image",
  componentId: "juydo-1"
})(["background-color:var(--layout-lib-background-color-light);block-size:100%;inline-size:100%;object-fit:contain;"]);
const sizeMap = {
  xxs: '1rem',
  xs: '1.5rem',
  sm: '2rem',
  md: '3rem',
  lg: '4.5rem',
  xl: '6rem'
};
const DefaultFallbackIcon = () => /*#__PURE__*/_jsx(IconCompanies, {
  variant: "disabled"
});
export const CompanyLogo = ({
  alt,
  fallbackIcon = /*#__PURE__*/_jsx(DefaultFallbackIcon, {}),
  src,
  size = 'md'
}) => {
  const imageSize = sizeMap[size];
  const [imageData, setImageData] = useState({
    src,
    alt,
    hasError: false
  });
  useEffect(() => {
    setImageData({
      src,
      alt,
      hasError: false
    });
  }, [src, alt]);
  const handleError = () => {
    setImageData(prev => {
      return Object.assign({}, prev, {
        hasError: true
      });
    });
  };
  return /*#__PURE__*/_jsx(StyledLayoutHorizontal, {
    $size: sizeMap[size],
    background: "background-color",
    blockSize: imageSize,
    borderRadius: "border-radius-full",
    flex: "0 0 auto",
    inlineSize: imageSize,
    justifyContent: "center",
    overflow: "hidden",
    children: imageData.hasError || !imageData.src ? fallbackIcon : /*#__PURE__*/_jsx(Image, {
      alt: alt,
      onError: handleError,
      src: src
    })
  });
};